module.exports = __webpack_public_path__ + "static/media/ActivityImg.a01855d5.png";